"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryAliasFilterToJSON = exports.RegistryAliasFilterFromJSONTyped = exports.RegistryAliasFilterFromJSON = exports.instanceOfRegistryAliasFilter = void 0;
/**
 * Check if a given object implements the RegistryAliasFilter interface.
 */
function instanceOfRegistryAliasFilter(value) {
    let isInstance = true;
    isInstance = isInstance && "registryFilterNames" in value;
    return isInstance;
}
exports.instanceOfRegistryAliasFilter = instanceOfRegistryAliasFilter;
function RegistryAliasFilterFromJSON(json) {
    return RegistryAliasFilterFromJSONTyped(json, false);
}
exports.RegistryAliasFilterFromJSON = RegistryAliasFilterFromJSON;
function RegistryAliasFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'registryFilterNames': json['registryFilterNames'],
    };
}
exports.RegistryAliasFilterFromJSONTyped = RegistryAliasFilterFromJSONTyped;
function RegistryAliasFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'registryFilterNames': value.registryFilterNames,
    };
}
exports.RegistryAliasFilterToJSON = RegistryAliasFilterToJSON;
